module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("\n        Identificação "), _c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v(" "), (_vm.type == 'reset') ? [_vm._v("Esqueci minha senha")] : _vm._e(), _vm._v(" "), (_vm.type == 'desbloqueioConta') ? [_vm._v("Desbloqueio de conta")] : _vm._e(), _vm._v(" "), (_vm.type == 'primeiroacesso') ? [_vm._v("Primeiro Acesso")] : _vm._e()], 2), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-yellow"
  }), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  }), _vm._v(" "), (_vm.type == 'reset') ? [_c('p', [_vm._v("Informe seu CPF ou CNPJ para redefinir a senha.")])] : _vm._e(), _vm._v(" "), (_vm.type == 'desbloqueioConta') ? [_c('p', [_vm._v("Informe seu CPF ou CNPJ para redefinir a senha.")])] : _vm._e(), _vm._v(" "), (_vm.type == 'primeiroacesso') ? [_c('p', [_vm._v("\n          O primeiro acesso destina-se aos novos clientes, que já fizeram uma\n          adesão Move Mais, mas ainda não criaram uma senha de acesso para\n          utilizar os serviços online.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          Se você ainda não é cliente, conheça nossos\n          "), _c('router-link', {
    staticClass: "make-link",
    attrs: {
      "to": {
        name: 'services'
      },
      "tag": "a"
    }
  }, [_vm._v("serviços e planos.")])], 1)] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row border-row row-fix"
  }, [_c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "content-box-small margin-t80"
  }, [(_vm.formState == 'ERROR' && _vm.errorMessage) ? _c('div', {
    staticClass: "alert alert-danger alert-dismissible margin-t20 margin-b20",
    attrs: {
      "role": "alert"
    }
  }, [_c('strong', [_vm._v("Erro: ")]), _vm._v("\n              " + _vm._s(_vm.errorMessage) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.formState == 'SUCCESS') ? _c('div', {
    staticClass: "alert alert-success alert-dismissible margin-t20",
    attrs: {
      "role": "alert"
    }
  }, [_c('strong', [_vm._v("Sucesso!")]), _vm._v("\n              Foi enviado um email para recuperação de senha\n            ")]) : _vm._e(), _vm._v(" "), (_vm.formState == 'NEW') ? _c('form', {
    attrs: {
      "autocomplete": "false",
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.doRequest.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group margin-b20",
    class: {
      'has-error': _vm.errors.has('taxIdNumber')
    }
  }, [_c('label', [_vm._v("CPF ou CNPJ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.taxIdNumber),
      expression: "taxIdNumber",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|cpfCnpj'),
      expression: "'required|cpfCnpj'"
    }, {
      name: "mask-cpf-cnpj",
      rawName: "v-mask-cpf-cnpj"
    }],
    staticClass: "form-control small",
    attrs: {
      "type": "tel",
      "inputmode": "numeric",
      "pattern": "^([A-Za-z0-9]{2}\\.[A-Za-z0-9]{3}\\.[A-Za-z0-9]{3}\\/[A-Za-z0-9]{4}-[0-9]{2}|[A-Za-z0-9]{12}[0-9]{2}|[0-9]{3}\\.[0-9]{3}\\.[0-9]{3}-[0-9]{2}|[0-9]{11})$",
      "name": "taxIdNumber",
      "data-vv-validate-on": "blur",
      "placeholder": "Digite seu CPF ou CNPJ",
      "maxlength": "18",
      "autofocus": "",
      "novalidate": "",
      "formnovalidate": ""
    },
    domProps: {
      "value": (_vm.taxIdNumber)
    },
    on: {
      "change": function($event) {
        _vm.taxIdNumber = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n                  " + _vm._s(_vm.errors.first("taxIdNumber")) + "\n                ")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-purple",
    attrs: {
      "id": "btn-login",
      "type": "submit",
      "name": "button"
    }
  }, [_vm._v("\n                Continuar\n              ")]), _vm._v(" "), _c('i', {
    staticClass: "icon-circle-right align-icon"
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.type == 'reset') ? [_c('div', {
    staticClass: "circle-key"
  })] : _vm._e(), _vm._v(" "), (_vm.type == 'desbloqueioConta') ? [_c('div', {
    staticClass: "circle-key"
  })] : _vm._e(), _vm._v(" "), (_vm.type == 'primeiroacesso') ? [_c('div', {
    staticClass: "circle"
  })] : _vm._e()], 2)]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-back margin-t20",
    attrs: {
      "to": "/login",
      "tag": "button"
    }
  }, [_c('i', {
    staticClass: "icon-circle-left align-icon-left"
  }), _vm._v("\n        Voltar\n      ")])], 1)]), _vm._v(" "), _c('modal-validate', {
    ref: "modalValidate",
    attrs: {
      "show": _vm.showValidationModal,
      "email": _vm.userEmail,
      "title": "Redefinição de senha",
      "resend-cooldown": 60,
      "initial-timer": _vm.initialTimerValue,
      "close-on-backdrop": false,
      "allow-close": true
    },
    on: {
      "close": _vm.closeValidationModal,
      "validate": _vm.onCodeValidate,
      "resend": _vm.onResendCode,
      "channel-selected": _vm.onChannelSelected
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-18256f0b!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/auth/password-request.vue
// module id = 2055
// module chunks = 1